import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
export function Modules() {
  const tomos = [{
    num: '01',
    title: 'Fundamentos del Craft Perfecto',
    color: 'bg-amber-50 border-amber-200',
    accent: 'text-amber-700',
    badge: 'bg-amber-100 text-amber-700',
    desc: 'El kit esencial, tipos de papel, gramajes, adhesivos correctos y el sistema Zero Waste. La base que nadie te enseñó y que todo lo demás necesita.',
    includes: ['Herramientas esenciales con precio real', 'Gramajes y compatibilidades', 'Sistema Zero Waste', 'Diagnóstico de tu kit actual']
  }, {
    num: '02',
    title: 'Estructuras de Álbumes Perfectos',
    color: 'bg-rose-50 border-rose-200',
    accent: 'text-rose-700',
    badge: 'bg-rose-100 text-rose-700',
    desc: 'Medidas exactas en cm, tapas que no se curvan, 8 formatos de álbum y el método 5-3-1 de composición para que cada página quede perfecta.',
    includes: ['8 formatos con plantillas milimétricas', 'Técnica anti-curvatura de tapas', 'Método 5-3-1 de composición', 'Proyecto práctico 20x20']
  }, {
    num: '03',
    title: 'Encuadernación Artesanal',
    color: 'bg-emerald-50 border-emerald-200',
    accent: 'text-emerald-700',
    badge: 'bg-emerald-100 text-emerald-700',
    desc: '5 técnicas de costura artesanal: Pamphlet, Longstitch, Coptic, French Link y Stab Binding. Sin máquinas costosas. Con resultado de taller profesional.',
    includes: ['5 técnicas de encuadernación cosida', 'Producción en lote', 'Reparación de libros dañados', 'Guía de hilo y agujas']
  }, {
    num: '04',
    title: 'Art Journaling y Mixed Media',
    color: 'bg-violet-50 border-violet-200',
    accent: 'text-violet-700',
    badge: 'bg-violet-100 text-violet-700',
    desc: 'El Sistema de 7 Capas que hace que toda página funcione. 12 técnicas de fondo, mixed media sin miedo, collage, lettering y cómo desarrollar un estilo propio.',
    includes: ['Sistema de 7 Capas completo', '12 técnicas de fondo', 'Tabla de compatibilidades de mediums', 'Ejercicio de los 9 — estilo propio']
  }, {
    num: '05',
    title: 'Planificación, Capas y Decoración',
    color: 'bg-sky-50 border-sky-200',
    accent: 'text-sky-700',
    badge: 'bg-sky-100 text-sky-700',
    desc: 'Teoría del color aplicada al craft, 20 paletas maestras listas, sistema de planificación de páginas en 10 minutos, flores de papel, stencils y fotografía que vende.',
    includes: ['20 paletas maestras con swatches', 'Planificador de página en 10 min', '8 técnicas de flores de papel', 'Sistema de fotografía con celular']
  }, {
    num: '06',
    title: 'Acabados de Lujo y Cierre',
    color: 'bg-orange-50 border-orange-200',
    accent: 'text-orange-700',
    badge: 'bg-orange-100 text-orange-700',
    desc: '7 acabados premium, pan de oro, foil transfer, embossing en seco y caliente, 12 sistemas de cierre, packaging de 4 niveles y la fórmula exacta de precio justo.',
    includes: ['7 acabados de lujo paso a paso', 'Pan de oro y foil transfer', 'Fórmula de precio artesanal', 'Packaging de 4 niveles']
  }];
  return <section id="tomos" className="py-16 sm:py-24 px-5 bg-brand-cream relative overflow-hidden" data-id="element-104">
      <div className="max-w-6xl mx-auto" data-id="element-105">
        <FadeIn className="text-center mb-12 sm:mb-16" data-id="element-106">
          <span className="inline-block text-brand-gold font-bold tracking-widest text-xs uppercase mb-4 border border-brand-gold/30 px-3 py-1 rounded-full" data-id="element-107">
            El sistema principal
          </span>
          <h3 className="text-4xl sm:text-6xl font-black text-brand-ink mt-4 mb-6" data-id="element-108">
            Los 6 Tomos Principales
          </h3>
          <p className="text-lg sm:text-xl text-brand-muted max-w-2xl mx-auto" data-id="element-109">
            Cada tomo es un módulo completo con técnica, práctica y proyecto
            terminado. Juntos forman el único sistema integral de craft
            artesanal en español.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-110">
          {tomos.map((tomo, i) => <FadeIn key={i} delay={i * 0.08} data-id="element-111">
              <div className={`relative p-6 sm:p-7 border ${tomo.color} hover:shadow-lg transition-all group rounded-2xl h-full flex flex-col`} data-id="element-112">
                <div className="flex items-start justify-between mb-5" data-id="element-113">
                  <span className={`${tomo.badge} text-xs font-black px-3 py-1 rounded-full uppercase tracking-wider`} data-id="element-114">
                    Tomo {tomo.num}
                  </span>
                  <BookOpenIcon className={`w-6 h-6 ${tomo.accent} opacity-60`} data-id="element-115" />
                </div>
                <h4 className="text-xl font-black text-brand-ink mb-3" data-id="element-116">
                  {tomo.title}
                </h4>
                <p className="text-brand-muted text-sm leading-relaxed mb-5 flex-1" data-id="element-117">
                  {tomo.desc}
                </p>
                <ul className="space-y-2 border-t border-current/10 pt-5 mt-auto" data-id="element-118">
                  {tomo.includes.map((item, j) => <li key={j} className="flex items-center gap-2" data-id="element-119">
                      <CheckIcon className={`w-4 h-4 ${tomo.accent} shrink-0`} data-id="element-120" />
                      <span className="text-brand-ink text-xs font-medium" data-id="element-121">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>)}
        </div>

        {/* Total pages callout */}
        <FadeIn delay={0.3} className="mt-12 text-center" data-id="element-122">
          <div className="inline-flex flex-wrap items-center justify-center gap-x-4 gap-y-4 sm:gap-4 bg-brand-paper border border-brand-line rounded-2xl px-6 sm:px-8 py-5 shadow-sm" data-id="element-123">
            <div className="text-center" data-id="element-124">
              <div className="text-3xl sm:text-4xl font-black text-brand-gold" data-id="element-125">
                910
              </div>
              <div className="text-xs text-brand-muted uppercase tracking-wider font-semibold" data-id="element-126">
                Páginas totales
              </div>
            </div>
            <div className="w-px h-10 bg-brand-line" data-id="element-127" />
            <div className="text-center" data-id="element-128">
              <div className="text-3xl sm:text-4xl font-black text-brand-gold" data-id="element-129">
                6
              </div>
              <div className="text-xs text-brand-muted uppercase tracking-wider font-semibold" data-id="element-130">
                Tomos completos
              </div>
            </div>
            <div className="w-px h-10 bg-brand-line" data-id="element-131" />
            <div className="text-center" data-id="element-132">
              <div className="text-3xl sm:text-4xl font-black text-brand-gold" data-id="element-133">
                $19.990
              </div>
              <div className="text-xs text-brand-muted uppercase tracking-wider font-semibold" data-id="element-134">
                Precio único
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}